import React from 'react';
import Title from '../title';
import $ from "jquery";
import Server from '../../functions/server';
import Permission from '../../functions/permission';
import Loading from '../loading';
import './purchaser.css';
import { Button, Grid, Input, Card } from 'semantic-ui-react';
import ReadCookie from '../../functions/readcookies';
import ViewAddress from './address';
import ViewContact from './contact';
import AddPurchaser from './addpurchaser';
import EditPurchaser from './editpurchaser';
import DeletePurchaser from './deletepurchaser';

class Purchaser extends React.Component {

  state = {
    load: false,
    message: '',
    purchaser: [],
    viewAddress: false,
    viewContact: false,
    addPurchaser: false,
    editPurchaser: false,
    deletePurchaser: false,
    viewEdit: '', menuPermission: []
  }

  componentDidMount() {
    this.getPurchaser();
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('add-purchaser', this.props.menus);
    this.setState({ menuPermission })
  }

  getPurchaser() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      addPurchaser: false,
      editPurchaser: false,
      deletePurchaser: false,
      load: true,
      message: 'Getting Purchaser Details'
    })
    $.ajax({
      type: 'POST',
      data: { 'userId': userId, 'where': 'Purchaser' },
      url: Server() + 'purchaser/getpurchaser.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            purchaser: data,
            load: false,
            data: true
          });
        } catch (e) {
          context.setState({
            load: false,
            purchaser: [],
            data: false
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false,
          data: false
        });
      }
    });
  }

  handleClose = () => {
    this.setState({
      viewAddress: false,
      viewContact: false,
      addPurchaser: false,
      editPurchaser: false,
      deletePurchaser: false,
    });
  }


  render() {
    let address, contact, add, edit, remove;
    if (this.state.viewAddress == true) {
      address = (<ViewAddress id={this.state.addressid}
                  menuPermission={this.state.menuPermission}
                  purchaseredit={this.state.purchaseredit}
                  handleClose={this.handleClose.bind(this)}
                  viewAddress={this.state.viewAddress} viewEdit={this.state.viewEdit} />);
    }
    if (this.state.viewContact) {
      contact = (<ViewContact id={this.state.contactid}
                  menuPermission={this.state.menuPermission}
                  purchaseredit={this.state.purchaseredit}
                  handleClose={this.handleClose.bind(this)}
                  viewContact={this.state.viewContact} viewEdit={this.state.viewEdit} />);
    }
    if (this.state.addPurchaser) {
      add =(<AddPurchaser handleClose={this.handleClose}
            getPurchaser={this.getPurchaser.bind(this)}
            addPurchaser={this.state.addPurchaser} />);
    }
    if (this.state.editPurchaser) {
      edit = (<EditPurchaser handleClose={this.handleClose}
              editid={this.state.editid} editname={this.state.editname}
              getPurchaser={this.getPurchaser.bind(this)}
              editPurchaser={this.state.editPurchaser}
              purchaseredit={this.state.purchaseredit}/>);
    }
    return (
      <div>
        <Title title={'Add Purchaser'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <div style={{padding: '2%', display: this.state.purchaserview}}>
                  <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={13}>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={3}>
                      <br/>
                      { this.state.menuPermission.add ?
                        <Button fluid primary onClick = { () => {this.setState({ addPurchaser: true }) } }
                                style={{ display: this.state.purchaseredit }}>
                          Add Purchaser
                        </Button>:''
                      }
                      
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <div id='scrolls'>
                      <table width='100%' id='table'>
                        <tr id='tableheader'>
                          <th style={{width: '7%'}}><center>Sino</center></th>
                          <th style={{width: '49%'}}><center>Purchaser Name</center></th>
                          <th style={{width: '15%'}}><center>View Address</center></th>
                          <th style={{width: '15%'}}><center>View Contact</center></th>
                          { this.state.menuPermission.edit ? 
                            <th style={{width: '7%'}}><center>Edit</center></th>: ''
                          }
                          
                        </tr>
                        { this.state.purchaser.map((z) => {
                            return (
                              <tr>
                                <td style={{padding: '2%'}}><center>{z.sino}</center></td>
                                <td style={{padding: '2%'}}><center>{z.name}</center></td>
                                <td style={{cursor: 'pointer'}}
                                    onClick={ () => { this.setState({ viewAddress: true, addressid: z.id }) } }>
                                  <center>View Address</center>
                                </td>
                                <td style={{cursor: 'pointer'}}
                                    onClick={ () => { this.setState({ viewContact: true, contactid: z.id }) } }>
                                  <center>View Contact</center>
                                </td>
                                { this.state.menuPermission.edit ? 
                                  <td style={{cursor: 'pointer'}}
                                    onClick={ () => { this.setState({ editPurchaser: true, editid: z.id,
                                                                      editname: z.name }) } }>
                                    <center>Edit</center>
                                  </td>: ''
                                }
                              </tr>
                            );
                          }
                        )}
                      </table>
                      </div>
                    </Grid.Column>
                  </Grid>
              </div>
              {address} {contact} {add} {edit} {remove}
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Purchaser;
